import React from 'react';
import { motion } from 'framer-motion';
import { Moon } from 'lucide-react';
export const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) => <motion.div initial={{
  opacity: 0,
  y: 24
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-100px'
}} transition={{
  duration: 0.8,
  delay,
  ease: [0.21, 0.47, 0.32, 0.98]
}} className={className} data-id="element-134">
    {children}
  </motion.div>;
export const Divider = () => <div className="flex items-center justify-center py-16 opacity-40" data-id="element-135">
    <div className="h-px w-16 bg-gradient-to-r from-transparent via-parchment-muted to-transparent" data-id="element-136"></div>
    <motion.div animate={{
    opacity: [0.4, 0.8, 0.4]
  }} transition={{
    duration: 4,
    repeat: Infinity,
    ease: 'easeInOut'
  }} className="mx-4 text-amber" data-id="element-137">
      <Moon size={14} strokeWidth={1.5} data-id="element-138" />
    </motion.div>
    <div className="h-px w-16 bg-gradient-to-l from-transparent via-parchment-muted to-transparent" data-id="element-139"></div>
  </div>;
export const Button = ({
  children,
  onClick,
  className = ''
}: {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}) => <motion.button whileHover={{
  scale: 1.02,
  boxShadow: '0 0 20px rgba(212, 154, 92, 0.2)'
}} whileTap={{
  scale: 0.98
}} onClick={onClick} className={`bg-amber text-midnight font-medium px-8 py-4 rounded-md transition-colors hover:bg-amber-hover flex items-center justify-center gap-2 ${className}`} data-id="element-140">
    {children}
  </motion.button>;